module.exports = __webpack_public_path__ + "static/media/secondary-1.06f0c62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-1.jpg
// module id = 167
// module chunks = 0